import { useTranslation } from 'react-i18next';
import { TRACK } from '@/track/track.constants';
import { doTrack } from '@/track/track.service';
import { Modal } from '@seeqdev/qomponents';

interface UnsavedChangesModalProps {
  onCancel: () => void;
  onDiscard: () => void;
}

export const UnsavedChangesModal = ({ onCancel, onDiscard }: UnsavedChangesModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={true}
      title={t('ITEM_ACL.UNSAVED_CHANGES.HEADER')}
      onClose={() => {
        doTrack(TRACK.ACCESS_CONTROL, 'confirmation dialog', 'cancel');
        onCancel();
      }}
      submitButtonLabel={t('ITEM_ACL.UNSAVED_CHANGES.DISCARD')}
      onSubmit={() => {
        doTrack(TRACK.ACCESS_CONTROL, 'confirmation dialog', 'discard');
        onDiscard();
      }}
      size="lg"
      cancelButtonLabel={t('CANCEL')}>
      <div>{t('ITEM_ACL.UNSAVED_CHANGES.MESSAGE')}</div>
    </Modal>
  );
};
